module.exports = __webpack_public_path__ + "img/form-x-3.f9b12aae.svg";